import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';
import { fetchExportBlob, BlobExportResult } from '../../scripts/export.blob.script';

export class ReportDA {
  static apiResponse: ApiResponse

  public static async getBalanceSheet(id_company: string, date: string): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/reports/balance-sheet`

    let config: any = {
      headers: { Authorization: authToken() },
      params: { date }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getIncomeStatement(id_company: string, from: string, to: string): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/reports/income-statement`

    let config: any = {
      headers: { Authorization: authToken() },
      params: { from, to }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getTrialBalance(
    id_company: string,
    from: string,
    to: string,
    opts?: { level?: string, sort_by?: string, sort_order?: string }
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/reports/trial-balance`

    let config: any = {
      headers: { Authorization: authToken() },
      params: {
        from,
        to,
        ...(opts?.level && { level: opts.level }),
        ...(opts?.sort_by && { sort_by: opts.sort_by }),
        ...(opts?.sort_order && { sort_order: opts.sort_order }),
      }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async exportBalanceSheet(
    id_company: string,
    format: 'xlsx' | 'pdf',
    params: { date: string; previous_date?: string; layout?: string; hide_zero?: boolean; lang?: string },
    fallbackName?: string
  ): Promise<BlobExportResult> {
    const url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/reports/balance-sheet/export`
    return fetchExportBlob(url, {
      format,
      date: params.date,
      previous_date: params.previous_date,
      layout: params.layout,
      hide_zero: params.hide_zero ? 'true' : undefined,
      lang: params.lang,
    }, fallbackName)
  }

  public static async exportIncomeStatement(
    id_company: string,
    format: 'xlsx' | 'pdf',
    params: { from: string; to: string; previous_from?: string; previous_to?: string; hide_zero?: boolean; lang?: string },
    fallbackName?: string
  ): Promise<BlobExportResult> {
    const url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/reports/income-statement/export`
    return fetchExportBlob(url, {
      format,
      from: params.from,
      to: params.to,
      previous_from: params.previous_from,
      previous_to: params.previous_to,
      hide_zero: params.hide_zero ? 'true' : undefined,
      lang: params.lang,
    }, fallbackName)
  }

  public static async exportJournal(
    id_company: string,
    format: 'xlsx' | 'pdf',
    params: { id_journal?: string; id_account?: string; date_from?: string; date_to?: string; q?: string; lang?: string },
    fallbackName?: string
  ): Promise<BlobExportResult> {
    const url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/accounting/entries/export`
    return fetchExportBlob(url, {
      format,
      id_journal: params.id_journal,
      id_account: params.id_account,
      date_from: params.date_from,
      date_to: params.date_to,
      q: params.q,
      lang: params.lang,
    }, fallbackName)
  }
}
